import type { ReactNode } from 'react';

export type CollapsableGroupId = string;

export const DEFAULT_COLLAPSABLE_GROUP_ID = 'default';

export type CollapsableTableExpandedByGroup = Record<string, boolean>;

export type CollapsableTableRenderApi = {
  isGroupExpanded: (groupId: string) => boolean;
  setGroupExpanded: (groupId: string, isExpanded: boolean) => void;
  toggleGroup: (groupId: string) => void;
};

export type CollapsableTableCellRenderContext<Row> = {
  row: Row;
  rowIndex: number;
  api: CollapsableTableRenderApi;
};

export type CollapsableTableTriggerRenderContext = {
  isExpanded: boolean;
  setExpanded: (isExpanded: boolean) => void;
  toggle: () => void;
};

export interface CollapsableTableTriggerProps {
  groupId?: CollapsableGroupId;
  children: (context: CollapsableTableTriggerRenderContext) => ReactNode;
}

export interface CollapsableTableColumn<Row> {
  id: string;
  header: ReactNode;
  groupId?: CollapsableGroupId;
  isCollapsable?: boolean;
  headerClassName?: string | ((api: CollapsableTableRenderApi) => string | undefined);
  cellClassName?: string | ((context: CollapsableTableCellRenderContext<Row>) => string | undefined);
  isVisible?: (api: CollapsableTableRenderApi) => boolean;
  renderCell: (context: CollapsableTableCellRenderContext<Row>) => ReactNode;
}

export interface CollapsableTableOptions<Row> {
  rows: Row[];
  columns: CollapsableTableColumn<Row>[];
  getRowKey?: (row: Row, rowIndex: number) => string | number;
  initialExpandedByGroup?: CollapsableTableExpandedByGroup;
  tableClassName?: string;
  tableE2E?: string;
}

export interface CollapsableTableProps<Row> {
  options: CollapsableTableOptions<Row>;
}
